// @flow
import { postCreator } from '../../http';
import environment from '../../environment';

export const endpoints = Object.freeze({
  POST_CONTACT_MESSAGE: `${environment.apiUrl}/report/contact`,
});

export const postContactMessageApi = postCreator(fetch, endpoints.POST_CONTACT_MESSAGE);



// WEBPACK FOOTER //
// ./src/modules/cargo/api.js